import { ProjectPhaseModel, PropertyTypeModel } from '../generated';
import { TEST_GEOMETRY } from '../geometry/geometry.test';
import { ExtendedConstructionNumber } from './api-utilities.types';
import { composeIncludeString } from './compose-include-string';
import { mergeDecimalRange } from './decimal-range/merge-decimal-range';
import {
    mergeConstructionNumberSpecification,
    mergePropertySpecification,
} from './decimal-range/merge-specification-range';
import { getApiObjectCenter, getApiObjectCoordinates } from './get/coordinates';
import { showPrice } from './show-price';

const propertyTypes: PropertyTypeModel[] = [
    {
        id: '1',
        geometry: TEST_GEOMETRY.apiGeometry,
        specifications: {
            bedrooms: {
                from: 5,
                to: 10,
            },
        },
    },
    {
        id: '2',
        specifications: {
            bedrooms: {
                from: 1,
            },
        },
    },
    {
        id: '3',
        specifications: {
            bedrooms: {
                from: 6,
                to: 11,
            },
        },
    },
];

const projectPhases: ProjectPhaseModel[] = [
    {
        id: '1',
        location: TEST_GEOMETRY.center,
        propertySpecifications: {
            plotArea: {
                from: 5,
            },
        },
    },
    {
        id: '2',
        propertySpecifications: {
            plotArea: {
                from: 20,
            },
        },
    },
];

const constructionNumbers: ExtendedConstructionNumber[] = [
    {
        id: '1',
        specifications: {
            rooms: {
                from: 5,
                to: 11,
            },
        },
        geometry: TEST_GEOMETRY.apiGeometry,
        status: 'InOption',
        objectType: 'constructionNumber',
    },
    {
        id: '2',
        specifications: {
            rooms: {
                from: 20,
                to: 30,
            },
        },
        status: 'Sold',
        objectType: 'constructionNumber',
    },
];

describe('Api utilities', function () {
    it('Expect propertyType specification to be merged', function () {
        expect(mergePropertySpecification({ propertyTypes }, 'bedrooms')).toEqual({
            from: 1,
            to: 11,
        });
    });

    it('Expect projectPhase specification to be merged', function () {
        expect(mergePropertySpecification({ projectPhases }, 'plotArea')).toEqual({
            from: 5,
            to: 20,
        });
    });

    it('Expect construction number specification to be merged', function () {
        expect(mergeConstructionNumberSpecification(constructionNumbers, 'rooms')).toEqual({
            from: 5,
            to: 30,
        });
    });

    it('Expect decimal range to be merged', function () {
        expect(mergeDecimalRange({ from: 0 }, { to: 5 })).toEqual({ from: 0, to: 5 });
        expect(mergeDecimalRange({}, {})).toEqual({});
    });

    it('Get coordinates from apiObject', function () {
        expect(getApiObjectCoordinates(constructionNumbers[0])).toEqual(TEST_GEOMETRY.coordinates);

        expect(getApiObjectCoordinates(constructionNumbers[1])).toBe(undefined);
    });

    it('Get center when location is set', function () {
        expect(getApiObjectCenter(projectPhases[0])).toEqual([[TEST_GEOMETRY.center]]);
        expect(getApiObjectCenter(projectPhases[1])).toBe(false);
    });

    it('Get center as Coordinate when location is set', function () {
        expect(getApiObjectCenter(projectPhases[0], { as: 'coordinate' })).toEqual(
            TEST_GEOMETRY.center,
        );
    });

    it('Get center when no location is set, but geometry is', function () {
        expect(getApiObjectCenter(propertyTypes[0])).toEqual([[TEST_GEOMETRY.center]]);
    });

    it('Compose api include string', function () {
        expect(composeIncludeString(['geometry', 'mainImage', 'areaProjectId'])).toBe(
            'geometry,mainImage,areaProjectId',
        );
    });

    it('Returns if price should be shown or not', function () {
        expect(showPrice({ constructionNumber: constructionNumbers[0] })).toBe(true);
        expect(showPrice({ constructionNumber: constructionNumbers[1] })).toBe(false);
    });
});
